import * as v from 'valibot';

export const ProgressTrackingTypeSchema = v.union([
  v.literal('CLICK'),
  v.literal('INTEGRATION'),
  v.literal('TOGGLE'),
  v.literal('NONE'),
  v.literal('SPECIAL'),
  v.literal('TEMPORAL'),
  v.literal('SELF'),
  v.literal('VISIBLE'),
]);

export type TProgressTrackingType = v.Output<typeof ProgressTrackingTypeSchema>;
